/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespPriceTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly priceTiles: ReadonlyArray<{
        readonly currency: string | null;
        readonly displayName: string | null;
        readonly image: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedPriceTile_itemSearch" | "SbRespTradeFreeShippingPromoTile_itemSearch">;
    readonly " $refType": "SbRespPriceTiles_itemSearch";
};
export type SbRespPriceTiles_itemSearch$data = SbRespPriceTiles_itemSearch;
export type SbRespPriceTiles_itemSearch$key = {
    readonly " $data"?: SbRespPriceTiles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespPriceTiles_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespPriceTiles_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "priceTiles",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "concreteType": "SearchBrowsePriceTile",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "image",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPriceTile_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeFreeShippingPromoTile_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '75c73df7d2d5ac0e8d987716a7fa52fe';
export default node;
